/**
 * The shape `donors.phone_e164` and its siblings are checked against in
 * Postgres — a `+` and 7 to 15 digits, not starting with 0. It carries no
 * numbering plan, so it costs nothing to load: `form-schema.ts`, which every
 * first screen with a form bundles, checks a phone answer's shape with it and
 * leaves the plan to the server (docs/decisions/0086).
 */
export const E164_PATTERN = /^\+[1-9][0-9]{6,14}$/;

export function isE164Shaped(value: string): boolean {
  return E164_PATTERN.test(value);
}
